<template>
  <div class="subpage main_area" style="position: relative">
    <div class="type_menu_area">
      <div class="type_menu">
        <div :class="type == 0 ? 'type_menu_item active' : 'type_menu_item'" @click="changType(0)"><span>站内信</span></div>
        <div :class="type == 1 ? 'type_menu_item active' : 'type_menu_item'" @click="changType(1)"><span>公告</span></div>
      </div>
    </div>
    <div class="loading">
      <div class="detail_area">
        <div class="layout position-relative">
          <!--站内信-->
          <ul class="announce_list" v-if="type == 0" id="zhanneixin" style="">
            <li v-for="(item, index) in noticeList" :key="index" @click="changInfo(item)">
              <div class="collapse">
                <div class="block_content">
                  <div class="thumb"><img src="/static/image/avatar_inbox.png" /></div>
                </div>
                <div class="block_content">
                  <div class="title">{{ item.title }}</div>
                </div>
                <div class="block_content">
                  <div class="type">{{ item.created_at }}</div>
                </div>
              </div>
              <div class="block_content " style="margin-top:6px">
                <div class="content">
                    <div v-html="item.content "></div>
                </div>
              </div>
            </li>
          </ul>

          <!--公告-->
          <ul class="announce_list announcement" v-if="type == 1">
            <li v-for="(item, index) in homenoticelis" :key="index" @click="changInfos(item)">
              <a href="javascript:;">
                <div class="collapse_a">
                  <div class="announcement_header">
                    <div class="announcement_title">公告</div>
                  </div>
                  <div class="announcement_content">
                    <div style="width: 100%">
                      <div class="announcement_message">{{ item }}</div>
                    </div>
                  </div>
                </div></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'message',
  data() {
    return { type: 0, noticeList: [], homenoticelis: [] };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type * 1;
    }
    that.$parent.showLoading();
    that.homenotice();
    that.getDatalist();
  },
  methods: {
    changType(val) {
      let that = this;
      if (this.type == val) {
        return;
      }
      this.type = val;
      that.hInfo = that.homenoticelis[0];
      that.noticeInfo = that.noticeList[0];
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.hInfo = that.homenoticelis[0];
        }
      });
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeList = res.data.data;
            that.noticeInfo = that.noticeList[0];
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/message.vue